/**
 * This is our environment-specific build configuration.
 */
export const environment = {
  /**
   * Whether this is a production environment
   */
  production: false,

  /**
   * Which media recorder the app should use. Must be one of the following values:
   * - 'auto': Any media recorder is fine.
   * - 'polyfill': Only use the polyfill.
   */
  mediaRecorderPreference: 'polyfill',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
